import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Hon'ble Chaudhary Charan Singh Ji</h1>
                <p>Home &gt; About-us &gt; Hon'ble Chaudhary Charan Singh Ji</p>
            </div>
        </div>
    )
}

export default Hero;